// extracted by mini-css-extract-plugin
module.exports = {"lightButton":"LrvCancelButton_lightButton__AWhqH","darkButton":"LrvCancelButton_darkButton__1WgFy"};